const MAX_ITER = 200;

export function normalizeFeeType(feeType) {
  if (feeType === 'XIRR') return 'Annual XIRR';
  if (feeType === 'Monthly Fee') return 'Monthly XIRR';
  return feeType ?? 'Annual XIRR';
}

export function resolveMonthlyFeePct(feeType, feePct) {
  const pct = Number(feePct) || 0;
  if (feeType === 'Monthly XIRR' || feeType === 'Monthly Fee') {
    return pct;
  }
  const annualDecimal = pct > 1 ? pct / 100 : pct;
  return ((1 + annualDecimal) ** (1 / 12) - 1) * 100;
}

export function monthlyFeePctToAnnualDecimal(monthlyFeePct) {
  const monthlyDecimal = Number(monthlyFeePct) / 100;
  return (1 + monthlyDecimal) ** 12 - 1;
}

export function buildMarginal(cumulativeRoas) {
  return cumulativeRoas.map((v, i) => (i === 0 ? v : v - cumulativeRoas[i - 1]));
}

export function extendRoasVector(cumulativeRoas) {
  const last = cumulativeRoas[cumulativeRoas.length - 1] || 0;
  cumulativeRoas.push(last + 1);
}

function streamToCashflows(stream) {
  if (!stream.length) return [];
  const minMonth = stream[0].month;
  const maxMonth = Math.max(...stream.map((p) => p.month));
  const cf = new Array(maxMonth - minMonth + 1).fill(0);
  for (const p of stream) {
    cf[p.month - minMonth] += p.amount;
  }
  return cf;
}

function computeMonthlyRate(cashflows) {
  if (!cashflows?.length) return NaN;
  let hasNeg = false;
  let hasPos = false;
  for (const v of cashflows) {
    if (v < 0) hasNeg = true;
    if (v > 0) hasPos = true;
  }
  if (!hasNeg || !hasPos) return NaN;

  let r = 0.01;
  for (let iter = 0; iter < MAX_ITER; iter++) {
    let npv = 0;
    let dnpv = 0;
    for (let t = 0; t < cashflows.length; t++) {
      const denom = (1 + r) ** t;
      npv += cashflows[t] / denom;
      if (t > 0) dnpv += (-t * cashflows[t]) / (1 + r) ** (t + 1);
    }
    if (Math.abs(npv) < 0.01) break;
    if (Math.abs(dnpv) < 1e-10) break;
    const newR = r - npv / dnpv;
    if (!Number.isFinite(newR)) return NaN;
    if (Math.abs(newR - r) < 1e-9) {
      r = newR;
      break;
    }
    r = newR;
    if (r <= -0.999) r = -0.999;
  }
  if (r <= -1) return -1;
  return r;
}

export function computeXirr(stream) {
  const cashflows = streamToCashflows(stream);
  const monthlyRate = computeMonthlyRate(cashflows);
  if (!Number.isFinite(monthlyRate)) return NaN;
  return (1 + monthlyRate) ** 12 - 1;
}
